module.exports = __webpack_public_path__ + "img/icon-logo.7777881b.png";